import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import { Hint } from 'app/design-system/components/Popper';

type MatchScoreboardCellWrapperProps = PropsWithChildren<{
  content: string;
  className?: string;
  isDivWrapperTag?:boolean;
}>;

const ScoreboardCellWrapper: FC<MatchScoreboardCellWrapperProps> = ({
  content,
  className,
  isDivWrapperTag = false,
  children,
}) => {
  return (
    <Hint content={content}
          childrenWrapperClassName={classNames('scoreboard-cells-wrapper', className)}
          childrenWrapperTag={isDivWrapperTag ? 'div' : 'li'}
          placement="top">
      {children}
    </Hint>
  );
};

export default ScoreboardCellWrapper;
